<div class="creative-card">
    <div class="creative-top">
        <div class="creative-top-row">
            <span class="creative-type-label">{{ formattedAdType }}</span>
            <div class="creative-platform-icons">
                <img *ngIf="hasFacebook" class="platform-icon" width="16" height="16" [src]="'svg/Facebook.svg' | assetVersion">
                <img *ngIf="hasInstagram" class="platform-icon" width="16" height="16" [src]="'svg/Instagram.svg' | assetVersion">
                <img *ngIf="hasMessenger" class="platform-icon" width="16" height="16" [src]="'svg/Messenger.svg' | assetVersion">
                <img *ngIf="hasThreads" class="platform-icon" width="16" height="16" [src]="'svg/Threads.svg' | assetVersion">
                <img *ngIf="hasAudienceNetwork" class="platform-icon" width="16" height="16" [src]="'svg/Meta.svg' | assetVersion">


            </div>
        </div>
        <div class="creative-metrics-row">
            <span class="metric-pair">
                <span class="metric-lbl">CPM</span>
                <span class="metric-val">{{ formattedCpm }}</span>
            </span>
            <span class="metric-pair">
                <span class="metric-lbl">Impressions</span>
                <span class="metric-val">{{ cardData.impressions | shortNumber }}</span>
            </span>
        </div>
    </div>
    <div class="creative-image-wrapper">
        <img *ngIf="!showEmptyCreative" [src]="cardData.creativeUrl" class="creative-image" loading="lazy" (error)="onImageError()">
        <img *ngIf="isVideo && !showEmptyCreative" class="video-play-button" [src]="'social-overview-assets/icons/videoPlayerIcon.svg' | assetVersion" alt="Play video">
        <div *ngIf="showEmptyCreative" class="empty-creative">
            <img class="empty-creative-icon" [src]="'svg/empty-creative.svg'| assetVersion" alt="">
            <span class="empty-creative-text">No preview available</span>
        </div>
    </div>
    <div class="creative-bottom">
        <div class="creative-brand-chip">
            <img *ngIf="cardData.brandLogoPath" class="brand-chip-logo" [src]="cardData.brandLogoPath" [alt]="cardData.brandName">
            <span class="brand-chip-name">{{ cardData.brandName }}</span>
        </div>
        <div class="creative-description" [class.no-description]="!hasDescription">{{ getDescription }}</div>
    </div>
</div>
